/* */
export const getCallState = state => state.phone.callState;

/* */
export const getPhoneOutcall = state => state.phone.phoneOutcall;

/* */
export const getPhoneMuted = state => state.phone.phoneMuted;

/* */
export const getPhoneOpen = state => state.phone.phoneOpen;

/* */
export const getOutdialNumber = state => state.phone.outdialNumber;
